import { Toaster as Sonner, toast } from 'sonner';
import { useAppStore } from '@/lib/store';

/** App-wide toast host (sonner), themed with tokens. Mounted once in App. */
export const Toaster = () => {
  const theme = useAppStore((s) => s.theme);
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      closeButton
      offset={16}
      toastOptions={{
        classNames: {
          toast: 'group !rounded-lg !border !border-border !bg-surface-raised !text-text !shadow-lg !font-sans',
          description: '!text-text-muted',
          actionButton: '!bg-primary !text-primary-foreground !font-medium',
          cancelButton: '!bg-surface-sunken !text-text',
          closeButton: '!bg-surface-raised !border-border !text-text-muted',
          success: '[&_[data-icon]]:!text-positive',
          error: '[&_[data-icon]]:!text-negative',
          warning: '[&_[data-icon]]:!text-warning',
          info: '[&_[data-icon]]:!text-info',
        },
      }}
    />
  );
};

/**
 * Undo pattern: perform the change optimistically, then offer Undo for 6 s.
 * `toastUndo('Marked 3 as reviewed', () => revert())`
 */
export const toastUndo = (message: string, onUndo: () => void, description?: string): string | number =>
  toast(message, { description, duration: 6000, action: { label: 'Undo', onClick: onUndo } });

export { toast };
